import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import Switch from "@mui/material/Switch";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";

import MoreVertIcon from "@mui/icons-material/MoreVert";

export default function OptionMenu({ details, handleQuestionTreeApi }) {
  const { t } = useTranslation();
  // local state
  const [showCurate, setShowCurate] = useState(
    Boolean(details.itemExtra.interactionView)
  );
  // menu
  const [anchorEl, setAnchorEl] = useState(null); // menu
  const handleOpen = (event) => setAnchorEl(event.currentTarget);
  const handleClose = () => setAnchorEl(false);
  const handleClick = (option) => () => {
    switch (option.id) {
      case "curate":
        setShowCurate((prev) => {
          handleQuestionTreeApi({
            type: "CURATE_VIEW",
            payload: +!prev,
          });
          return !prev;
        });
        break;
      default:
        break;
    }
    // close the menu
    handleClose();
  };

  const menuOptions = [
    {
      id: "curate",
      title: "Simplified view",
      icon: <Switch color="primary" checked={showCurate} />,
    },
  ];

  return (
    <div>
      <IconButton onClick={handleOpen} size="large">
        <MoreVertIcon fontSize="small" />
      </IconButton>
      <Menu
        id="menu-clients-options"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        keepMounted
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        disableScrollLock={true}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {menuOptions.map((option) => (
          <MenuItem key={option.id} onClick={handleClick(option)}>
            <List dense={true} style={{ margin: "0", padding: "0" }}>
              <ListItem style={{ margin: "0", padding: "0" }}>
                <ListItemIcon style={{ minWidth: 36 }}>
                  {option.icon}
                </ListItemIcon>

                <ListItemText primary={option.title} />
              </ListItem>
            </List>
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
}
